<template>
    <div class="bl-format-settings">
        <div class="dialog-header">
            <div class="header-icon">
                <i class="el-icon-s-management"></i>
            </div>
            <div>
                <div class="header-title">{{ $t('blFormatSettings.headerTitle',{previewBlNo: previewBlNo, mode: previewMode ? $t('blFormatSettings.previewMdoe') : (downloadMode ? $t('blFormatSettings.downloadMode') : '')}) }}</div>
                <div class="header-subtitle">{{ previewMode ? $t('blFormatSettings.headerSubTitle-preview') : (downloadMode ? $t('blFormatSettings.headerSubTitle-download') : '')}}</div>
            </div>
        </div>

        <!-- 主内容区 -->
        <div class="main-content">
            <!-- 左侧设置面板 -->
            <div class="settings-panel">
                <!-- 预览模板选择 -->
                <div class="section" v-if="previewMode">
                    <div class="section-title">
                        <i class="el-icon-document"></i>
                        {{$t('blFormatSettings.choosePreviewTemplate')}}
                    </div>
                    <div class="options-container">
                        <div class="option-card"
                            :class="{selected: previewTemplate === 0}"
                            @click="previewTemplate = 0">
                            <div class="recommended-badge" v-show="previewTemplate == 0">{{$t('blFormatSettings.currentSelected')}}</div>
                            <div class="option-title">{{$t('blFormatSettings.blConfimationTemplate')}}</div>
<!--                            <div class="option-subtitle english-text">B/L Confirmation</div>-->
<!--                            <p style="color: #4b5563;margin-bottom: 8px;">{{$t('blFormatSettings.blConfimationTemplateTips')}}</p>-->
<!--                            <p class="english-text">Default B/L preview format for most scenarios</p>-->
                        </div>

                        <div
                            class="option-card"
                            :class="{selected: previewTemplate === 1}"
                            @click="previewTemplate = 1">
                            <div class="recommended-badge" v-show="previewTemplate == 1">{{$t('blFormatSettings.currentSelected')}}</div>
                            <div class="option-title">{{$t('blFormatSettings.feederBlConfimationTemplate')}}</div>
<!--                            <div class="option-subtitle english-text">(Feeder) B/L Confirmation</div>-->
<!--                            <p style="color: #4b5563;margin-bottom: 8px;">{{$t('blFormatSettings.feederBlConfimationTemplateTips')}}</p>-->
<!--                            <p class="english-text">For B/L issued by feeder vessel to mother vessel</p>-->
                        </div>

<!--                        <div-->
<!--                            class="option-card"-->
<!--                            :class="{selected: previewTemplate === 2}"-->
<!--                            @click="previewTemplate = 2">-->
<!--                            <div class="recommended-badge" v-show="previewTemplate == 2">{{$t('blFormatSettings.currentSelected')}}</div>-->
<!--                            <div class="option-title">{{$t('blFormatSettings.lastBlConfimationTemplate')}}</div>-->
<!--&lt;!&ndash;                            <div class="option-subtitle english-text">(Last Main Route) B/L Confirmation</div>&ndash;&gt;-->
<!--                            <p style="color: #4b5563;margin-bottom: 8px;">{{$t('blFormatSettings.lastBlConfimationTemplateTips')}}</p>-->
<!--&lt;!&ndash;                            <p class="english-text">For B/L of the last leg trunk line transportation</p>&ndash;&gt;-->
<!--                        </div>-->
                        <div style="width: 48%">
                        </div>
                    </div>
                </div>

                <!-- 箱信息类型选择 -->
                <div class="section">
                    <div class="section-title">
                        <i class="el-icon-box"></i>
                        {{$t('blFormatSettings.chooseContainerFormat')}}
                    </div>

                    <div class="options-container">
                        <div class="option-card"
                            :class="{selected: containerFormat == 7,disabled: isCard7Disabled}"
                            @click="handleCardClick(7)"
                        >
                            <div class="recommended-badge" v-show="!isCard7Disabled && containerFormat == 7">{{$t('blFormatSettings.currentSelected')}}</div>
                            <div class="option-title">{{$t('blFormatSettings.ctnNo-sealNo-size')}}</div>

                            <div class="tag-container">
                                <span class="tag">{{$t('blFormatSettings.containerNo')}}</span>
                                <span class="tag">{{$t('blFormatSettings.sealNo')}}</span>
                                <span class="tag">{{$t('blFormatSettings.size')}}</span>
                            </div>

                            <p class="info-text">{{$t('blFormatSettings.simpleContainerInfoTips')}}</p>
                        </div>

                        <div
                            class="option-card"
                            :class="{selected: containerFormat == 9,disabled: isCard9Disabled}"
                            @click="handleCardClick(9)">
                            <div class="recommended-badge" v-show="!isCard9Disabled && containerFormat == 9">{{$t('blFormatSettings.currentSelected')}}</div>
                            <div class="option-title">{{$t('blFormatSettings.ctnNo-sealNo-size-jmt')}}</div>

                            <div class="tag-container">
                                <span class="tag">{{$t('blFormatSettings.containerNo')}}</span>
                                <span class="tag">{{$t('blFormatSettings.sealNo')}}</span>
                                <span class="tag">{{$t('blFormatSettings.size')}}</span>
                                <span class="tag">{{$t('blFormatSettings.quantity')}}</span>
                                <span class="tag">{{$t('blFormatSettings.grossWeight')}}</span>
                                <span class="tag">{{$t('blFormatSettings.volume')}}</span>
                            </div>

                            <p class="info-text">{{$t('blFormatSettings.completeContainerInfoTips')}}</p>
                        </div>

                        <div
                            class="option-card"
                            :class="{selected: containerFormat == 12,disabled: isCard12Disabled}"
                            @click="handleCardClick(12)">
                            <div class="recommended-badge" v-show="!isCard12Disabled && containerFormat == 12">{{$t('blFormatSettings.currentSelected')}}</div>
                            <div class="option-title">{{$t('blFormatSettings.ctnNo-sealNo-size-jmt-hm-hscode')}}</div>

                            <div class="tag-container">
                                <span class="tag">{{$t('blFormatSettings.containerNo')}}</span>
                                <span class="tag">{{$t('blFormatSettings.sealNo')}}</span>
                                <span class="tag">{{$t('blFormatSettings.size')}}</span>
                                <span class="tag">{{$t('blFormatSettings.quantity')}}</span>
                                <span class="tag">{{$t('blFormatSettings.grossWeight')}}</span>
                                <span class="tag">{{$t('blFormatSettings.volume')}}</span>
                                <span class="tag">{{$t('blFormatSettings.cargoDesc')}}</span>
                                <span class="tag">{{$t('blFormatSettings.hsCode')}}</span>
                            </div>

                            <p class="info-text">{{$t('blFormatSettings.specialContainerInfoTips')}}</p>
                        </div>

                        <div v-if="isSGP"
                            class="option-card"
                           :class="{selected: containerFormat === 11,disabled: isCard11Disabled}"
                           @click="handleCardClick(11)">
                        <div class="recommended-badge" v-show="!isCard11Disabled && containerFormat == 11">{{$t('blFormatSettings.currentSelected')}}</div>
                        <div class="option-title">{{$t('blFormatSettings.ctnNo-sealNo-size-vol')}}</div>

                        <div class="tag-container">
                          <span class="tag">{{$t('blFormatSettings.containerNo')}}</span>
                          <span class="tag">{{$t('blFormatSettings.sealNo')}}</span>
                          <span class="tag">{{$t('blFormatSettings.containerType')}}</span>
                          <span class="tag">{{$t('blFormatSettings.quantity')}}</span>
                          <span class="tag">{{$t('blFormatSettings.grossWeight')}}</span>
                          <span class="tag">{{$t('blFormatSettings.tareWeight')}}</span>
                          <span class="tag">{{$t('blFormatSettings.volume')}}</span>
                        </div>

                        <p class="info-text">{{$t('blFormatSettings.completeContainerInfoTips2')}}</p>
                      </div>

                        <div style="width: 48%">
                      </div>
                    </div>
                </div>

                <!-- 货描显示内容设置 -->
                <div class="section" v-show="false">
                    <div class="section-title">
                        <i class="el-icon-setting"></i>
                        {{$t('blFormatSettings.cargoDescOptions')}}
                    </div>
                    
                    <div class="checkbox-container">
                        <label class="checkbox-item">
                            <input 
                                type="checkbox" 
                                v-model="showContainerDetails"
                                class="checkbox-input"
                            >
                            <span class="checkbox-custom"></span>
                            <span class="checkbox-label">{{$t('blFormatSettings.cntrOgsShow')}}</span>
                        </label>
                    </div>
                </div>
            </div>

            <!-- 右侧预览面板 -->
            <div class="preview-panel" v-if="previewMode && !showFootBtn">
                <div class="preview-header">
<!--                    <div class="preview-title">提单预览</div>-->
                    <div class="preview-actions">
                        <button class="refresh-btn" @click="fetchReportUrl" :disabled="isLoading">
                            <i class="el-icon-view"></i>
                            <span>{{$t('blFormatSettings.previewBtn')}}</span>
                        </button>
                        <button class="cancel-btn" @click="handleCancel">
                            <i class="el-icon-close"></i>
                            <span>{{$t('blFormatSettings.closeBtn')}}</span>
                        </button>
                    </div>
                </div>
                <div class="preview-container">
                    <div class="preview-placeholder" v-if="!previewUrl">
                        <i class="el-icon-document"></i>
                        <h3>{{$t('blFormatSettings.previewRefreshTips')}}</h3>
                    </div>

                    <iframe
                        v-else
                        :key="previewUrl"
                        :src="previewUrl"
                        class="preview-iframe"
                        frameborder="0"
                        allowfullscreen
                        @load="onIframeLoad"
                        @error="onIframeError"
                    ></iframe>

                    <div class="preview-indicator" v-if="isLoading">
                        <i class="el-icon-loading"></i>
                        <h3>{{$t('blFormatSettings.loadingTips')}}</h3>
                    </div>
                </div>
            </div>
        </div>

        <!-- 底部按钮区域 -->
        <div class="dialog-footer" v-if="showFootBtn">
            <button class="footer-btn btn-cancel" @click="handleCancel">
                <i class="el-icon-close"></i>
                {{$t('blFormatSettings.cancelBtn')}}
            </button>
            <button v-show="previewMode" class="footer-btn btn-preview" @click="handlePreview">
                <i class="el-icon-download"></i>
                {{$t('blFormatSettings.downloadBtn')}}
            </button>
            <button v-show="downloadMode" class="footer-btn btn-preview" @click="handleDownload">
                <i class="el-icon-download"></i>
                {{$t('blFormatSettings.downloadBtn')}}
            </button>
        </div>
    </div>
</template>

<script>
import { showMessage } from '../utils/message.js';

export default {
    name: 'BlFormatSettings',
    data() {
        return {
            // 预览模板选择 (0:提单确认件, 1:支线签大船, 2:末程干线)
            previewTemplate: 0,
            // 箱信息类型选择 (7:箱号/封号/箱尺寸, 9:箱号/箱型/封号/件毛体, 11:箱号/封号/箱型/件毛皮体 )
            containerFormat: 7,
            // 指定的箱信息类型（有指定类型时，不可更改）
            fixedContainerType: null,
            // 报表预览URL
            previewUrl: '',
            // 加载状态
            isLoading: false,
            // 显示分箱件重尺
            showContainerDetails: false
        }
    },
    computed: {
        // 预览提单id - 使用computed确保响应props变化
        previewBookingHeadId() {
            return this.initialBookingHeadId;
        },
        // 预览提单号 - 使用computed确保响应props变化
        previewBlNo() {
            return this.initialBlNo;
        },
        isSGP() {
          // 判断是否为“新加坡”主体
          const entityType = this.$apiUtils.getCurrentEntity();
          return entityType === "2";
        },
        isCard7Disabled() {
            return this.fixedContainerType !== null && this.fixedContainerType !== "7"
        },
        isCard9Disabled() {
            return this.fixedContainerType !== null && this.fixedContainerType !== "9"
        },
        isCard11Disabled() {
            return this.fixedContainerType !== null && this.fixedContainerType !== "11"
        },
        isCard12Disabled() {
            return this.fixedContainerType !== null && this.fixedContainerType !== "12"
        }
    },
    props: {
        // 预览模式
        previewMode: {
            type: Boolean,
            default: false
        },
        // 下载模式
        downloadMode: {
            type: Boolean,
            default: false
        },
        // 是否显示预览面板
        showFootBtn: {
            type: Boolean,
            default: false
        },
        // 初始预览提单号
        initialBlNo: {
            type: String,
            default: ''
        },
        // 初始预览提单id
        initialBookingHeadId: {
            type: String,
            default: ''
        },
        // 初始预览模板
        initialPreviewTemplate: {
            type: Number,
            default: 0
        },
        // 初始箱信息类型
        initialContainerFormat: {
            type: Number,
            default: 7
        },
        // 对话框显示状态
        visible: {
            type: Boolean,
            default: false
        },
        // 初始指定箱信息类型
        initialFixedContainerType: {
            type: String,
            default: null
        },
    },
    watch: {
        // 监听组件显示状态，当重新打开时清空报表页面
        visible: {
            handler(newVal) {
                if (newVal) {
                    // 组件重新打开时，清空报表页面
                    this.previewUrl = '';
                    this.isLoading = false;
                }
            },
            immediate: true
        },
        // 监听提单号变化
        initialBlNo: {
            handler(newVal, oldVal) {
                if (newVal !== oldVal) {
                    // 提单号变化时，清空预览内容
                    this.previewUrl = '';
                    this.isLoading = false;
                }
            }
        },
        // 监听提单ID变化
        initialBookingHeadId: {
            handler(newVal, oldVal) {
                if (newVal !== oldVal) {
                    // 提单ID变化时，清空预览内容
                    this.previewUrl = '';
                    this.isLoading = false;
                }
            }
        },
        // 监听固定箱信息类型变化
        initialFixedContainerType: {
            handler(newVal, oldVal) {
                if (newVal !== oldVal) {
                    this.fixedContainerType = this.initialFixedContainerType;
                    if (this.initialFixedContainerType !== null && this.initialFixedContainerType !== "") {
                        this.containerFormat = this.initialFixedContainerType;
                    } else {
                        this.containerFormat = this.initialContainerFormat;
                    }
                }
            }
        }
    },
    created() {
        // 初始化数据
        this.previewTemplate = this.initialPreviewTemplate;
        this.fixedContainerType = this.initialFixedContainerType;
        if (this.initialFixedContainerType !== null && this.initialFixedContainerType !== "") {
            this.containerFormat = this.initialFixedContainerType;
        } else {
            this.containerFormat = this.initialContainerFormat;
        }
    },
    methods: {
        handleCancel() {
            this.$emit('cancel');
        },
        handlePreview() {
            // 传递选择的模板类型、箱信息类型和货描显示设置给父组件
            this.$emit('preview', {
                previewTemplateType: this.previewTemplate,
                containerInfoType: this.containerFormat,
                cargoDescQGSShowFlag: this.showContainerDetails
            });
            // 关闭弹框
            this.$emit('cancel');
        },
        handleDownload() {
            // 传递选择的箱信息类型和货描显示设置给父组件
            this.$emit('download', {
                containerInfoType: this.containerFormat,
                cargoDescQGSShowFlag: this.showContainerDetails
            });
            // 关闭弹框
            this.$emit('cancel');
        },
        // 箱信息类型卡片点击事件
        handleCardClick(val) {
            if (this.isCard7Disabled) return
            if (this.isCard9Disabled) return
            if (this.isCard11Disabled) return
            if (this.isCard12Disabled) return

            this.containerFormat = val
        },
        // 获取报表URL
        async fetchReportUrl() {
            this.isLoading = true;

            try {
                // 模拟API调用 - 实际项目中替换为真实API
                const response = await this.previewAction();
                // 设置预览URL
                this.previewUrl = response.data.url;
                
                // 强制刷新iframe内容
                this.$nextTick(() => {
                    const iframe = this.$el.querySelector('.preview-iframe');
                    if (iframe) {
                        // 先清空src，然后重新设置，强制刷新
                        iframe.src = '';
                        setTimeout(() => {
                            iframe.src = this.previewUrl;
                        }, 100);
                    }
                });
            } catch (error) {
                console.error('获取报表URL失败:', error);
                this.$message({
                    message: this.$t('blFormatSettings.previewFailedTips'),
                    type: 'error',
                    duration: 3000
                });
            } finally {
                this.isLoading = false;
            }
        },
        previewAction() {
            return new Promise((resolve, reject) => {
                this.axios({
                    method: 'post',
                    url: '/api/booking/billOfLadingPreview',
                    data: {
                        bookingHeadId: this.previewBookingHeadId,
                        blNo: this.previewBlNo,
                        containerInfoType: this.containerFormat,
                        blTemplate: this.previewTemplate,
                        cargoDescQGSShowFlag: this.showContainerDetails
                    },
                    headers: {
                        'Accept-language': localStorage.getItem("locale")
                    }
                }).then(response => {
                    this.responseCode = response.data.backMessage;
                    if (response.data.backCode === "200") {
                        const reportUrl = response.data.object.toString();
                        // 如果返回的是相对路径，使用当前域名
                        const fullUrl = reportUrl.startsWith('http') ? reportUrl : `${window.location.origin}${reportUrl}`;
                        console.log('处理后的URL:', fullUrl);
                        resolve({
                            data: {
                                url: fullUrl,
                                path: window.location.origin
                            }
                        });
                    } else {
                        this.$message({
                            message: this.responseCode,
                            type: 'error',
                            duration: 3000
                        });
                        reject(new Error(this.responseCode));
                    }
                }).catch(error => {
                    if (error.data) {
                        this.responseCode = error.data.backMessage;
                        this.$message({
                            message: this.responseCode,
                            type: 'error',
                            duration: 3000
                        });
                    } else {
                        this.$message({
                            message: error.toString(),
                            type: 'error',
                            duration: 3000
                        });
                    }
                    reject(error);
                });
            });
        },
        onIframeLoad() {
            // console.log('Iframe loaded successfully');
            // console.log('Iframe src:', this.previewUrl);
            // this.$message({
            //     message: '预览加载完成 | Preview loaded successfully',
            //     type: 'success',
            //     duration: 2000
            // });
        },
        onIframeError(event) {
            console.error('Iframe error:', event);
            this.$message({
                message: '预览加载失败 | Failed to load preview',
                type: 'error',
                duration: 3000
            });
        },
    }
}
</script>

<style scoped>
* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

body {
    background: linear-gradient(135deg, #3a0a0e, #6d1b20);
    min-height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;
    font-family: 'Helvetica Neue', Arial, sans-serif;
}

.bl-format-settings {
    width: 90%;
    max-width: none;
    background: white;
    border-radius: 0;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
    overflow: hidden;
    display: flex;
    flex-direction: column;
    height: 90vh;
    margin: 0 auto;
}

.dialog-header {
    background: #a9161d;
    color: white;
    padding: 18px 20px;
    display: flex;
    align-items: center;
    position: relative;
}

.header-icon {
    font-size: 26px;
    margin-right: 15px;
    background: rgba(255, 255, 255, 0.2);
    width: 48px;
    height: 48px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.header-title {
    font-size: 17px;
    font-weight: 600;
}

.header-subtitle {
    font-size: 13px;
    font-weight: 400;
    opacity: 0.9;
    margin-top: 5px;
}

.main-content {
    display: flex;
    flex: 1;
    overflow: hidden;
}

.settings-panel {
    width: 40%;
    background: #f9fafb;
    padding: 25px 25px 0 25px;
    overflow-y: auto;
    border-right: 1px solid #eaeaea;
}

.preview-panel {
    width: 60%;
    background: #f5f5f5;
    display: flex;
    flex-direction: column;
    position: relative;
}

.preview-header {
    padding: 10px 20px;
    background: #e9ecef;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.preview-title {
    font-size: 17px;
    font-weight: 600;
    color: #333;
}

.preview-actions {
    display: flex;
    gap: 10px;
}

.preview-container {
    flex: 1;
    padding: 15px;
    overflow: auto;
    background: #fff;
    min-height: 1180px;
    position: relative;
}

.preview-placeholder {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
    color: #6c757d;
    overflow: hidden;
}

.preview-placeholder i {
    font-size: 48px;
    margin-bottom: 15px;
    color: #a9161d;
}

.preview-iframe {
    width: 100%;
    height: 100%;
    min-height: 500px;
    border: none;
    background: white;
    box-shadow: 0 2px 10px rgba(0,0,0,0.1);
    border-radius: 4px;
}

.section {
    background: white;
    border-radius: 10px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
    padding: 25px;
    margin-bottom: 30px;
    border-left: 4px solid #a9161d;
}

.section-title {
    font-size: 16px;
    font-weight: 600;
    color: #1f2937;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
}

.section-title i {
    margin-right: 10px;
    color: #a9161d;
}

.options-container {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
}

.option-card {
    flex: 1;
    min-width: 250px;
    border: 2px solid #e5e7eb;
    border-radius: 10px;
    padding: 10px;
    cursor: pointer;
    transition: all 0.3s ease;
    position: relative;
    background: white;
    font-size: 12px;
}

.option-card:hover {
    transform: translateY(-3px);
    box-shadow: 0 6px 15px rgba(0, 0, 0, 0.1);
    border-color: #a9161d;
}

.option-card.selected {
    border-color: #a9161d;
    background-color: #fdf2f2;
}

.option-card.disabled {
    opacity: 0.5;
    cursor: not-allowed; /* 禁用状态显示禁止光标 */
}

.option-title {
    font-size: 15px;
    font-weight: 600;
    color: #1f2937;
    margin-top: 8px;
    margin-bottom: 10px;
}

.option-subtitle {
    font-size: 14px;
    color: #4b5563;
    margin-bottom: 5px;
    min-height: 40px;
}

.tag-container {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 10px;
}

.tag {
    background: #fce4e6;
    color: #a9161d;
    padding: 5px 10px;
    border-radius: 20px;
    font-size: 12px;
    font-weight: 500;
}

.recommended-badge {
    position: absolute;
    top: -12px;
    right: 15px;
    background: #a9161d;
    color: white;
    padding: 4px 15px;
    font-size: 12px;
    font-weight: 600;
    border-radius: 4px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.info-text {
    color: #6b7280;
    font-size: 12px;
    margin-top: 15px;
    padding-top: 15px;
    border-top: 1px dashed #e5e7eb;
}

/* 复选框容器样式 */
.checkbox-container {
    margin-top: 15px;
    padding: 15px;
    background: #f9fafb;
    border-radius: 8px;
    border: 1px solid #e5e7eb;
}

.checkbox-item {
    display: flex;
    align-items: center;
    cursor: pointer;
    user-select: none;
    transition: all 0.3s ease;
}

.checkbox-item:hover {
    transform: translateX(2px);
}

.checkbox-input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
}

.checkbox-custom {
    position: relative;
    height: 18px;
    width: 18px;
    background-color: #ffffff;
    border: 2px solid #d1d5db;
    border-radius: 4px;
    margin-right: 12px;
    transition: all 0.3s ease;
    flex-shrink: 0;
}

.checkbox-item:hover .checkbox-custom {
    border-color: #a9161d;
    box-shadow: 0 0 0 3px rgba(169, 22, 29, 0.1);
}

.checkbox-input:checked ~ .checkbox-custom {
    background-color: #a9161d;
    border-color: #a9161d;
}

.checkbox-input:checked ~ .checkbox-custom:after {
    content: '';
    position: absolute;
    left: 4px;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
}

.checkbox-label {
    font-size: 14px;
    font-weight: 500;
    color: #374151;
    line-height: 1.4;
}

.dialog-footer {
    padding: 20px 30px;
    background: white;
    display: flex;
    justify-content: flex-end;
    gap: 15px;
    border-top: 1px solid #e5e7eb;
}

.footer-btn {
    padding: 10px 20px;
    border-radius: 5px;
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    border: none;
    display: flex;
    align-items: center;
}

.footer-btn i {
    margin-right: 8px;
}

.btn-cancel {
    background: #ffffff;
    color: #6c757d;
    border: 1px solid #dee2e6;
}

.btn-cancel:hover {
    background: #f8f9fa;
    color: #495057;
    border-color: #adb5bd;
}

.btn-preview {
    background: #a9161d;
    color: white;
}

.btn-preview:hover {
    background: #8c1218;
    box-shadow: 0 4px 8px rgba(169, 22, 29, 0.3);
}

.btn-preview:active {
    transform: translateY(2px);
}

.english-text {
    color: #4b5563;
    font-weight: 500;
}

.preview-indicator {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: rgba(255, 255, 255, 0.9);
    padding: 20px 40px;
    border-radius: 8px;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
    display: flex;
    flex-direction: column;
    align-items: center;
    z-index: 1000;
    pointer-events: none;
}

.preview-indicator i {
    margin-bottom: 15px;
    font-size: 36px;
    color: #a9161d;
    animation: rotate 1.5s linear infinite;
}

@keyframes rotate {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
}

.refresh-btn {
    background: #a9161d;
    color: white;
    border: none;
    padding: 8px 15px;
    border-radius: 4px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 5px;
    transition: all 0.3s;
}

.refresh-btn:hover {
    background: #8c1218;
}

.refresh-btn:active {
    transform: translateY(1px);
}

.cancel-btn {
    background: #f3f4f6;
    color: #4b5563;
    border: none;
    padding: 8px 15px;
    border-radius: 4px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 5px;
    transition: all 0.3s;
}

.cancel-btn:hover {
    background: #e5e7eb;
}

.cancel-btn:active {
    transform: translateY(1px);
}

/* 当只显示设置面板时的样式调整 */
.main-content:has(.settings-panel:only-child) .settings-panel {
    width: 100%;
    border-right: none;
}

/* 当只显示预览面板时的样式调整 */
.main-content:has(.preview-panel:only-child) .preview-panel {
    width: 100%;
}

@media (max-width: 1200px) {
    .main-content {
        flex-direction: column;
    }

    .settings-panel, .preview-panel {
        width: 100%;
        height: 50%;
    }

    .preview-panel {
        border-top: 1px solid #eaeaea;
    }
}

@media (max-width: 768px) {
    .options-container {
        flex-direction: column;
    }

    .option-card {
        min-width: 100%;
    }

    .footer-btn {
        padding: 12px 20px;
        font-size: 14px;
    }

    .dialog-header {
        padding: 18px 20px;
    }

    .settings-panel {
        padding: 20px;
    }

    .description {
        margin-bottom: 25px;
        color: #4b5563;
        line-height: 1.6;
        padding: 15px;
        background: white;
        border-radius: 10px;
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
        border-left: 4px solid #3b82f6;
    }
}
</style>